import { Component, Input } from '@angular/core';
import { ECVideoService } from '../../shared/ec-modal/ec-video.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';

@Component({
  selector: 'lp2-videos-carousel',
  templateUrl: './videos-carousel.component.html',
  styleUrls: ['./videos-carousel.component.scss'],
})
export class VideosCarouselComponent extends ImmersionCarouselComponent {
  @Input()
  title: string;

  @Input()
  ECLoaded: boolean;

  @Input()
  ECError: boolean;

  @Input()
  protected includedTopics: string[];

  @Input()
  protected excludedTopics: string[];

  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.videosPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_VIDEO)
      : 0;
  }

  videosPoints: number;

  loading = false;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService,
    private videoService: ECVideoService
  ) {
    super(service, levelProgressService, 'VIDEOS');

    this.subscription.add(
      this.videoService.loading.subscribe((loading) => {
        this.loading = loading;
      })
    );

    this.subscription.add(
      this.videoService.onClose.subscribe((id: number) => {
        this.reloadCourseTileById(id);
      })
    );
  }

  viewVideo(video: StudyBundleCourseDto) {
    if (this.loading) {
      return;
    }
    this.videoService.open(video);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/videos-carousel/videos-carousel.component.ts